import { defineDomainTranslations } from './defineDomainTranslations';

const en = {
  'upsell.action.maybeLater': 'Maybe later',
  'upsell.action.orSwitchToAnnual': 'Or switch to annual and keep your minutes all year',
  'upsell.action.orUpgradeTo': 'Or upgrade to {plan}',
  'upsell.action.startTranslating': 'Start translating',
  'upsell.action.switchToAnnual': 'Switch to annual · {price}',
  'upsell.action.upgradeTo': 'Upgrade to {plan} · {price}',
  'upsell.banner.annualDayOneText':
    'On annual, all {minutes} minutes are available from day one and stay available all year. Save {amount} a year.',
  'upsell.banner.annualNowText':
    'On annual, all {minutes} minutes are available now and stay available all year. Save {amount} a year.',
  'upsell.banner.annualShortText': 'All {minutes} minutes now, available all year. Save {amount} a year.',
  'upsell.banner.businessGivesMonth':
    'Business gives you {minutes} minutes a month, plus Dictionary and several languages at once.',
  'upsell.banner.businessGivesYear':
    'Business gives you {minutes} minutes for the year, plus Dictionary and several languages at once.',
  'upsell.banner.businessText': 'Get {minutes} minutes a month and Dictionary for consistent terms.',
  'upsell.banner.businessTitle': 'Translate into several languages at once on Business.',
  'upsell.banner.creatorProGivesMonth':
    'Creator Pro gives you {minutes} minutes a month, plus lip-synced downloads and subtitles.',
  'upsell.banner.creatorProGivesYear':
    'Creator Pro gives you {minutes} minutes for the year, plus lip-synced downloads and subtitles.',
  'upsell.banner.creatorProText': 'Get {minutes} minutes a month, subtitles on video and SRT export.',
  'upsell.banner.creatorProTitle': 'Download lip-synced videos on Creator Pro.',
  'upsell.banner.dismiss': 'Dismiss',
  'upsell.banner.fullYearTitle': 'Get your full year of minutes now.',
  'upsell.banner.usedHalfMonth': "You've used half of your minutes this month.",
  'upsell.banner.usedHalfYear': "You've used half of your yearly minutes.",
  'upsell.counter.left': '{minutes} min left',
  'upsell.counter.used': '{percent}% used · {minutes} min left',
  'upsell.download.annualTitle': 'Get your full year of minutes now',
  'upsell.download.businessTitle': 'Translate into several languages at once',
  'upsell.download.creatorProTitle': 'Take this video further with Creator Pro',
  'upsell.download.dictionary': 'Keep your wording consistent across projects with Dictionary',
  'upsell.download.done': 'Your video is downloaded',
  'upsell.download.doneAudio': 'Your audio is downloaded',
  'upsell.download.doneSubtitles': 'Your subtitles are downloaded',
  'upsell.download.lipSync': 'Download it with multispeaker lip-sync',
  'upsell.download.multilanguage': 'Multilingual batch translation in one click',
  'upsell.download.subtitles': 'Add subtitles or export SRT files',
  'upsell.feature.dictionary': 'Keep terms consistent with Dictionary',
  'upsell.feature.lipSync': 'Multispeaker Lip-sync included',
  'upsell.feature.minutesInsteadMonth': '{minutes} minutes a month instead of {from}',
  'upsell.feature.minutesInsteadYear': '{minutes} minutes a year instead of {from}',
  'upsell.feature.minutesPerMonth': '{minutes} minutes a month',
  'upsell.feature.minutesPerMonthShort': '{minutes} minutes/month',
  'upsell.feature.minutesPerYear': '{minutes} minutes for the year',
  'upsell.feature.minutesStay': 'Minutes stay available all year',
  'upsell.feature.multilanguage': 'Translate into several languages at once',
  'upsell.feature.poolDayOne': 'All {minutes} minutes available from day one',
  'upsell.feature.poolUpfront': 'All {minutes} minutes available upfront',
  'upsell.feature.save': 'Save {amount}',
  'upsell.feature.saveYear': 'Save {amount} a year',
  'upsell.feature.subtitles': 'Add subtitles and export SRT files',
  'upsell.hero.annualPlan': '{plan} Annual',
  'upsell.hero.current': 'Current · {plan} · {minutes} min',
  'upsell.hero.fullYear': 'Full year · available now',
  'upsell.hero.lipSync': 'Lip-sync',
  'upsell.hero.minutes': '{minutes} min',
  'upsell.hero.multiplier': '{multiplier}× minutes',
  'upsell.hero.savePerYear': 'Save {amount}/yr',
  'upsell.price.perMonth': '{price}/mo',
  'upsell.price.perYear': '{price}/yr',
  'upsell.usage.annualTitle': 'Keep your minutes for the whole year',
  'upsell.usage.tierMonthTitle': 'Get {minutes} minutes a month on {plan}',
  'upsell.usage.tierMultiplierTitle': 'Get {multiplier}× the minutes on {plan}',
  'upsell.usage.tierYearTitle': 'Get {minutes} minutes a year on {plan}',
  'upsell.usage.usedMonth': "You've used {used} of {total} minutes this month",
  'upsell.usage.usedYear': "You've used {used} of {total} minutes this year",
  'upsell.welcome.dictionary': 'Dictionary to keep terms consistent',
  'upsell.welcome.includes': 'Your plan includes',
  'upsell.welcome.languages': '135+ languages, with editing for every line',
  'upsell.welcome.lipSyncDownloads': 'Lip-synced video downloads',
  'upsell.welcome.lipSyncSubtitles': 'Lip-synced downloads and subtitles',
  'upsell.welcome.minutesMonth': '{minutes} minutes a month for dubbing and translation',
  'upsell.welcome.minutesYear': '{minutes} minutes for the year, available now',
  'upsell.welcome.multilanguage': 'Translation into several languages in one click',
  'upsell.welcome.needMore': 'Need more?',
  'upsell.welcome.offerMonth': '{plan} gives you {minutes} minutes a month, plus:',
  'upsell.welcome.offerYear': '{plan} Annual gives you {minutes} minutes for the year, plus:',
  'upsell.welcome.srtVoices': 'SRT export and up to 3 saved voices',
  'upsell.welcome.subtitlesSrt': 'Subtitles on video, SRT export and import',
  'upsell.welcome.title': 'Welcome to {plan}',
  'upsell.welcome.voiceCloning': "Voice cloning that keeps the speaker's voice",
} as const;

type UpsellTranslation = Record<keyof typeof en, string>;

const es = {
  'upsell.action.maybeLater': 'Quizá más tarde',
  'upsell.action.orSwitchToAnnual': 'O cámbiate al plan anual y conserva tus minutos todo el año',
  'upsell.action.orUpgradeTo': 'O cámbiate a {plan}',
  'upsell.action.startTranslating': 'Empezar a traducir',
  'upsell.action.switchToAnnual': 'Cambiar al plan anual · {price}',
  'upsell.action.upgradeTo': 'Cambiar a {plan} · {price}',
  'upsell.banner.annualDayOneText':
    'Con el plan anual, los {minutes} minutos están disponibles desde el primer día y siguen disponibles todo el año. Ahorra {amount} al año.',
  'upsell.banner.annualNowText':
    'Con el plan anual, los {minutes} minutos están disponibles ya y siguen disponibles todo el año. Ahorra {amount} al año.',
  'upsell.banner.annualShortText':
    'Todos los {minutes} minutos disponibles ya y durante todo el año. Ahorra {amount} al año.',
  'upsell.banner.businessGivesMonth':
    'Business te da {minutes} minutos al mes, además del diccionario y la traducción a varios idiomas a la vez.',
  'upsell.banner.businessGivesYear':
    'Business te da {minutes} minutos para todo el año, además del diccionario y la traducción a varios idiomas a la vez.',
  'upsell.banner.businessText':
    'Consigue {minutes} minutos al mes y el diccionario para mantener la coherencia de los términos.',
  'upsell.banner.businessTitle': 'Traduce a varios idiomas a la vez con Business.',
  'upsell.banner.creatorProGivesMonth':
    'Creator Pro te da {minutes} minutos al mes, además de descargas con Lip-sync y subtítulos.',
  'upsell.banner.creatorProGivesYear':
    'Creator Pro te da {minutes} minutos para todo el año, además de descargas con Lip-sync y subtítulos.',
  'upsell.banner.creatorProText': 'Consigue {minutes} minutos al mes, subtítulos en el video y exportación SRT.',
  'upsell.banner.creatorProTitle': 'Descarga videos con Lip-sync en Creator Pro.',
  'upsell.banner.dismiss': 'Descartar',
  'upsell.banner.fullYearTitle': 'Consigue ya los minutos de todo el año.',
  'upsell.banner.usedHalfMonth': 'Has usado la mitad de tus minutos de este mes.',
  'upsell.banner.usedHalfYear': 'Has usado la mitad de tus minutos anuales.',
  'upsell.counter.left': 'quedan {minutes} min',
  'upsell.counter.used': '{percent}% usado · quedan {minutes} min',
  'upsell.download.annualTitle': 'Consigue ya los minutos de todo el año',
  'upsell.download.businessTitle': 'Traduce a varios idiomas a la vez',
  'upsell.download.creatorProTitle': 'Saca más partido a este video con Creator Pro',
  'upsell.download.dictionary': 'Mantén una terminología coherente en todos tus proyectos con el diccionario',
  'upsell.download.done': 'Tu video se ha descargado',
  'upsell.download.doneAudio': 'Tu audio se ha descargado',
  'upsell.download.doneSubtitles': 'Tus subtítulos se han descargado',
  'upsell.download.lipSync': 'Descárgalo con Lip-sync para varios hablantes',
  'upsell.download.multilanguage': 'Traducción a varios idiomas en un solo clic',
  'upsell.download.subtitles': 'Añade subtítulos o exporta archivos SRT',
  'upsell.feature.dictionary': 'Mantén la coherencia de los términos con el diccionario',
  'upsell.feature.lipSync': 'Lip-sync para varios hablantes incluido',
  'upsell.feature.minutesInsteadMonth': '{minutes} minutos al mes en lugar de {from}',
  'upsell.feature.minutesInsteadYear': '{minutes} minutos al año en lugar de {from}',
  'upsell.feature.minutesPerMonth': '{minutes} minutos al mes',
  'upsell.feature.minutesPerMonthShort': '{minutes} minutos/mes',
  'upsell.feature.minutesPerYear': '{minutes} minutos para todo el año',
  'upsell.feature.minutesStay': 'Los minutos siguen disponibles todo el año',
  'upsell.feature.multilanguage': 'Traduce a varios idiomas a la vez',
  'upsell.feature.poolDayOne': 'Los {minutes} minutos disponibles desde el primer día',
  'upsell.feature.poolUpfront': 'Los {minutes} minutos disponibles desde el principio',
  'upsell.feature.save': 'Ahorra {amount}',
  'upsell.feature.saveYear': 'Ahorra {amount} al año',
  'upsell.feature.subtitles': 'Añade subtítulos y exporta archivos SRT',
  'upsell.hero.annualPlan': '{plan} anual',
  'upsell.hero.current': 'Actual · {plan} · {minutes} min',
  'upsell.hero.fullYear': 'Año completo · disponible ya',
  'upsell.hero.lipSync': 'Lip-sync',
  'upsell.hero.minutes': '{minutes} min',
  'upsell.hero.multiplier': '{multiplier}× minutos',
  'upsell.hero.savePerYear': 'Ahorra {amount}/año',
  'upsell.price.perMonth': '{price}/mes',
  'upsell.price.perYear': '{price}/año',
  'upsell.usage.annualTitle': 'Conserva tus minutos todo el año',
  'upsell.usage.tierMonthTitle': 'Consigue {minutes} minutos al mes con {plan}',
  'upsell.usage.tierMultiplierTitle': 'Consigue {multiplier}× los minutos con {plan}',
  'upsell.usage.tierYearTitle': 'Consigue {minutes} minutos al año con {plan}',
  'upsell.usage.usedMonth': 'Has usado {used} de {total} minutos este mes',
  'upsell.usage.usedYear': 'Has usado {used} de {total} minutos este año',
  'upsell.welcome.dictionary': 'Diccionario para mantener la coherencia de los términos',
  'upsell.welcome.includes': 'Tu plan incluye',
  'upsell.welcome.languages': 'Más de 135 idiomas, con edición de cada línea',
  'upsell.welcome.lipSyncDownloads': 'Descargas de video con Lip-sync',
  'upsell.welcome.lipSyncSubtitles': 'Descargas con Lip-sync y subtítulos',
  'upsell.welcome.minutesMonth': '{minutes} minutos al mes para doblaje y traducción',
  'upsell.welcome.minutesYear': '{minutes} minutos para todo el año, disponibles ya',
  'upsell.welcome.multilanguage': 'Traducción a varios idiomas en un solo clic',
  'upsell.welcome.needMore': '¿Necesitas más?',
  'upsell.welcome.offerMonth': '{plan} te da {minutes} minutos al mes y además:',
  'upsell.welcome.offerYear': '{plan} anual te da {minutes} minutos para todo el año y además:',
  'upsell.welcome.srtVoices': 'Exportación SRT y hasta 3 voces guardadas',
  'upsell.welcome.subtitlesSrt': 'Subtítulos en el video, exportación e importación de SRT',
  'upsell.welcome.title': 'Te damos la bienvenida a {plan}',
  'upsell.welcome.voiceCloning': 'Clonación de voz que conserva la voz de cada hablante',
} satisfies UpsellTranslation;

const pt = {
  'upsell.action.maybeLater': 'Talvez mais tarde',
  'upsell.action.orSwitchToAnnual': 'Ou mude para o plano anual e mantenha seus minutos o ano todo',
  'upsell.action.orUpgradeTo': 'Ou faça upgrade para o {plan}',
  'upsell.action.startTranslating': 'Começar a traduzir',
  'upsell.action.switchToAnnual': 'Mudar para o anual · {price}',
  'upsell.action.upgradeTo': 'Fazer upgrade para o {plan} · {price}',
  'upsell.banner.annualDayOneText':
    'No plano anual, todos os {minutes} minutos ficam disponíveis desde o primeiro dia e durante o ano todo. Economize {amount} por ano.',
  'upsell.banner.annualNowText':
    'No plano anual, todos os {minutes} minutos ficam disponíveis agora e durante o ano todo. Economize {amount} por ano.',
  'upsell.banner.annualShortText':
    'Todos os {minutes} minutos agora, disponíveis o ano todo. Economize {amount} por ano.',
  'upsell.banner.businessGivesMonth':
    'O Business oferece {minutes} minutos por mês, além do Dicionário e da tradução para vários idiomas de uma vez.',
  'upsell.banner.businessGivesYear':
    'O Business oferece {minutes} minutos para o ano inteiro, além do Dicionário e da tradução para vários idiomas de uma vez.',
  'upsell.banner.businessText': 'Tenha {minutes} minutos por mês e o Dicionário para manter os termos consistentes.',
  'upsell.banner.businessTitle': 'Traduza para vários idiomas de uma vez no Business.',
  'upsell.banner.creatorProGivesMonth':
    'O Creator Pro oferece {minutes} minutos por mês, além de downloads com Lip-sync e legendas.',
  'upsell.banner.creatorProGivesYear':
    'O Creator Pro oferece {minutes} minutos para o ano inteiro, além de downloads com Lip-sync e legendas.',
  'upsell.banner.creatorProText': 'Tenha {minutes} minutos por mês, legendas no vídeo e exportação de SRT.',
  'upsell.banner.creatorProTitle': 'Baixe vídeos com Lip-sync no Creator Pro.',
  'upsell.banner.dismiss': 'Dispensar',
  'upsell.banner.fullYearTitle': 'Garanta agora os minutos do ano inteiro.',
  'upsell.banner.usedHalfMonth': 'Você usou metade dos seus minutos deste mês.',
  'upsell.banner.usedHalfYear': 'Você usou metade dos seus minutos anuais.',
  'upsell.counter.left': 'restam {minutes} min',
  'upsell.counter.used': '{percent}% usado · restam {minutes} min',
  'upsell.download.annualTitle': 'Garanta agora os minutos do ano inteiro',
  'upsell.download.businessTitle': 'Traduza para vários idiomas de uma vez',
  'upsell.download.creatorProTitle': 'Vá além com este vídeo no Creator Pro',
  'upsell.download.dictionary': 'Mantenha a terminologia consistente em todos os projetos com o Dicionário',
  'upsell.download.done': 'Seu vídeo foi baixado',
  'upsell.download.doneAudio': 'Seu áudio foi baixado',
  'upsell.download.doneSubtitles': 'Suas legendas foram baixadas',
  'upsell.download.lipSync': 'Baixe com Lip-sync para vários locutores',
  'upsell.download.multilanguage': 'Tradução para vários idiomas em um clique',
  'upsell.download.subtitles': 'Adicione legendas ou exporte arquivos SRT',
  'upsell.feature.dictionary': 'Mantenha os termos consistentes com o Dicionário',
  'upsell.feature.lipSync': 'Lip-sync para vários locutores incluído',
  'upsell.feature.minutesInsteadMonth': '{minutes} minutos por mês em vez de {from}',
  'upsell.feature.minutesInsteadYear': '{minutes} minutos por ano em vez de {from}',
  'upsell.feature.minutesPerMonth': '{minutes} minutos por mês',
  'upsell.feature.minutesPerMonthShort': '{minutes} minutos/mês',
  'upsell.feature.minutesPerYear': '{minutes} minutos para o ano inteiro',
  'upsell.feature.minutesStay': 'Os minutos ficam disponíveis o ano todo',
  'upsell.feature.multilanguage': 'Traduza para vários idiomas de uma vez',
  'upsell.feature.poolDayOne': 'Todos os {minutes} minutos disponíveis desde o primeiro dia',
  'upsell.feature.poolUpfront': 'Todos os {minutes} minutos disponíveis desde já',
  'upsell.feature.save': 'Economize {amount}',
  'upsell.feature.saveYear': 'Economize {amount} por ano',
  'upsell.feature.subtitles': 'Adicione legendas e exporte arquivos SRT',
  'upsell.hero.annualPlan': '{plan} Anual',
  'upsell.hero.current': 'Atual · {plan} · {minutes} min',
  'upsell.hero.fullYear': 'Ano inteiro · disponível agora',
  'upsell.hero.lipSync': 'Lip-sync',
  'upsell.hero.minutes': '{minutes} min',
  'upsell.hero.multiplier': '{multiplier}× minutos',
  'upsell.hero.savePerYear': 'Economize {amount}/ano',
  'upsell.price.perMonth': '{price}/mês',
  'upsell.price.perYear': '{price}/ano',
  'upsell.usage.annualTitle': 'Mantenha seus minutos o ano todo',
  'upsell.usage.tierMonthTitle': 'Tenha {minutes} minutos por mês no {plan}',
  'upsell.usage.tierMultiplierTitle': 'Multiplique seus minutos por {multiplier} no {plan}',
  'upsell.usage.tierYearTitle': 'Tenha {minutes} minutos por ano no {plan}',
  'upsell.usage.usedMonth': 'Você usou {used} de {total} minutos este mês',
  'upsell.usage.usedYear': 'Você usou {used} de {total} minutos este ano',
  'upsell.welcome.dictionary': 'Dicionário para manter os termos consistentes',
  'upsell.welcome.includes': 'Seu plano inclui',
  'upsell.welcome.languages': 'Mais de 135 idiomas, com edição de cada fala',
  'upsell.welcome.lipSyncDownloads': 'Downloads de vídeo com Lip-sync',
  'upsell.welcome.lipSyncSubtitles': 'Downloads com Lip-sync e legendas',
  'upsell.welcome.minutesMonth': '{minutes} minutos por mês para dublagem e tradução',
  'upsell.welcome.minutesYear': '{minutes} minutos para o ano inteiro, disponíveis agora',
  'upsell.welcome.multilanguage': 'Tradução para vários idiomas em um clique',
  'upsell.welcome.needMore': 'Precisa de mais?',
  'upsell.welcome.offerMonth': 'O {plan} oferece {minutes} minutos por mês, além de:',
  'upsell.welcome.offerYear': 'O {plan} Anual oferece {minutes} minutos para o ano inteiro, além de:',
  'upsell.welcome.srtVoices': 'Exportação de SRT e até 3 vozes salvas',
  'upsell.welcome.subtitlesSrt': 'Legendas no vídeo, exportação e importação de SRT',
  'upsell.welcome.title': 'Boas-vindas ao {plan}',
  'upsell.welcome.voiceCloning': 'Clonagem de voz que preserva a voz de cada locutor',
} satisfies UpsellTranslation;

const fr = {
  'upsell.action.maybeLater': 'Peut-être plus tard',
  'upsell.action.orSwitchToAnnual': "Ou passez à l'offre annuelle et gardez vos minutes toute l'année",
  'upsell.action.orUpgradeTo': 'Ou passez à {plan}',
  'upsell.action.startTranslating': 'Commencer à traduire',
  'upsell.action.switchToAnnual': "Passer à l'offre annuelle · {price}",
  'upsell.action.upgradeTo': 'Passer à {plan} · {price}',
  'upsell.banner.annualDayOneText':
    "Avec l'offre annuelle, les {minutes} minutes sont disponibles dès le premier jour et le restent toute l'année. Économisez {amount} par an.",
  'upsell.banner.annualNowText':
    "Avec l'offre annuelle, les {minutes} minutes sont disponibles dès maintenant et le restent toute l'année. Économisez {amount} par an.",
  'upsell.banner.annualShortText':
    "Les {minutes} minutes dès maintenant, disponibles toute l'année. Économisez {amount} par an.",
  'upsell.banner.businessGivesMonth':
    'Business vous donne {minutes} minutes par mois, ainsi que le dictionnaire et la traduction en plusieurs langues à la fois.',
  'upsell.banner.businessGivesYear':
    "Business vous donne {minutes} minutes pour l'année, ainsi que le dictionnaire et la traduction en plusieurs langues à la fois.",
  'upsell.banner.businessText':
    'Obtenez {minutes} minutes par mois et le dictionnaire pour garantir la cohérence des termes.',
  'upsell.banner.businessTitle': 'Traduisez dans plusieurs langues à la fois avec Business.',
  'upsell.banner.creatorProGivesMonth':
    'Creator Pro vous donne {minutes} minutes par mois, ainsi que des téléchargements de vidéos avec Lip-sync et des sous-titres.',
  'upsell.banner.creatorProGivesYear':
    "Creator Pro vous donne {minutes} minutes pour l'année, ainsi que des téléchargements de vidéos avec Lip-sync et des sous-titres.",
  'upsell.banner.creatorProText':
    "Obtenez {minutes} minutes par mois, des sous-titres intégrés à la vidéo et l'export au format SRT.",
  'upsell.banner.creatorProTitle': 'Téléchargez des vidéos avec Lip-sync grâce à Creator Pro.',
  'upsell.banner.dismiss': 'Masquer',
  'upsell.banner.fullYearTitle': "Obtenez dès maintenant les minutes de toute l'année.",
  'upsell.banner.usedHalfMonth': 'Vous avez utilisé la moitié de vos minutes ce mois-ci.',
  'upsell.banner.usedHalfYear': 'Vous avez utilisé la moitié de vos minutes annuelles.',
  'upsell.counter.left': '{minutes} min restantes',
  'upsell.counter.used': '{percent} % utilisés · {minutes} min restantes',
  'upsell.download.annualTitle': "Obtenez dès maintenant les minutes de toute l'année",
  'upsell.download.businessTitle': 'Traduisez dans plusieurs langues à la fois',
  'upsell.download.creatorProTitle': 'Allez plus loin avec cette vidéo grâce à Creator Pro',
  'upsell.download.dictionary': 'Gardez une terminologie cohérente dans tous vos projets grâce au dictionnaire',
  'upsell.download.done': 'Votre vidéo a été téléchargée',
  'upsell.download.doneAudio': 'Votre audio a été téléchargé',
  'upsell.download.doneSubtitles': 'Vos sous-titres ont été téléchargés',
  'upsell.download.lipSync': 'Téléchargez-la avec le Lip-sync pour plusieurs locuteurs',
  'upsell.download.multilanguage': 'Traduction dans plusieurs langues en un clic',
  'upsell.download.subtitles': 'Ajoutez des sous-titres ou exportez des fichiers SRT',
  'upsell.feature.dictionary': 'Des termes cohérents grâce au dictionnaire',
  'upsell.feature.lipSync': 'Lip-sync pour plusieurs locuteurs inclus',
  'upsell.feature.minutesInsteadMonth': '{minutes} minutes par mois au lieu de {from}',
  'upsell.feature.minutesInsteadYear': '{minutes} minutes par an au lieu de {from}',
  'upsell.feature.minutesPerMonth': '{minutes} minutes par mois',
  'upsell.feature.minutesPerMonthShort': '{minutes} minutes/mois',
  'upsell.feature.minutesPerYear': "{minutes} minutes pour l'année",
  'upsell.feature.minutesStay': "Les minutes restent disponibles toute l'année",
  'upsell.feature.multilanguage': 'Traduisez dans plusieurs langues à la fois',
  'upsell.feature.poolDayOne': 'Les {minutes} minutes disponibles dès le premier jour',
  'upsell.feature.poolUpfront': 'Les {minutes} minutes disponibles immédiatement',
  'upsell.feature.save': 'Économisez {amount}',
  'upsell.feature.saveYear': 'Économisez {amount} par an',
  'upsell.feature.subtitles': 'Ajoutez des sous-titres et exportez des fichiers SRT',
  'upsell.hero.annualPlan': '{plan} annuel',
  'upsell.hero.current': 'Offre actuelle · {plan} · {minutes} min',
  'upsell.hero.fullYear': 'Toute l’année · disponible dès maintenant',
  'upsell.hero.lipSync': 'Lip-sync',
  'upsell.hero.minutes': '{minutes} min',
  'upsell.hero.multiplier': '{multiplier}× minutes',
  'upsell.hero.savePerYear': 'Économisez {amount}/an',
  'upsell.price.perMonth': '{price}/mois',
  'upsell.price.perYear': '{price}/an',
  'upsell.usage.annualTitle': "Gardez vos minutes toute l'année",
  'upsell.usage.tierMonthTitle': 'Obtenez {minutes} minutes par mois avec {plan}',
  'upsell.usage.tierMultiplierTitle': 'Multipliez vos minutes par {multiplier} avec {plan}',
  'upsell.usage.tierYearTitle': 'Obtenez {minutes} minutes par an avec {plan}',
  'upsell.usage.usedMonth': 'Vous avez utilisé {used} minutes sur {total} ce mois-ci',
  'upsell.usage.usedYear': 'Vous avez utilisé {used} minutes sur {total} cette année',
  'upsell.welcome.dictionary': 'Un dictionnaire pour des termes cohérents',
  'upsell.welcome.includes': 'Votre offre comprend',
  'upsell.welcome.languages': 'Plus de 135 langues, avec la modification de chaque réplique',
  'upsell.welcome.lipSyncDownloads': 'Téléchargements de vidéos avec Lip-sync',
  'upsell.welcome.lipSyncSubtitles': 'Téléchargements avec Lip-sync et sous-titres',
  'upsell.welcome.minutesMonth': '{minutes} minutes par mois pour le doublage et la traduction',
  'upsell.welcome.minutesYear': "{minutes} minutes pour l'année, disponibles dès maintenant",
  'upsell.welcome.multilanguage': 'Traduction dans plusieurs langues en un clic',
  'upsell.welcome.needMore': 'Besoin de plus ?',
  'upsell.welcome.offerMonth': '{plan} vous donne {minutes} minutes par mois, et aussi :',
  'upsell.welcome.offerYear': "{plan} annuel vous donne {minutes} minutes pour l'année, et aussi :",
  'upsell.welcome.srtVoices': "Export SRT et jusqu'à 3 voix enregistrées",
  'upsell.welcome.subtitlesSrt': 'Sous-titres sur la vidéo, export et import SRT',
  'upsell.welcome.title': 'Bienvenue dans {plan}',
  'upsell.welcome.voiceCloning': 'Clonage vocal qui conserve la voix de chaque locuteur',
} satisfies UpsellTranslation;

const it = {
  'upsell.action.maybeLater': 'Forse più tardi',
  'upsell.action.orSwitchToAnnual': "Oppure passa all'annuale e conserva i tuoi minuti tutto l'anno",
  'upsell.action.orUpgradeTo': 'Oppure passa a {plan}',
  'upsell.action.startTranslating': 'Inizia a tradurre',
  'upsell.action.switchToAnnual': "Passa all'annuale · {price}",
  'upsell.action.upgradeTo': 'Passa a {plan} · {price}',
  'upsell.banner.annualDayOneText':
    "Con il piano annuale, tutti i {minutes} minuti sono disponibili dal primo giorno e restano disponibili tutto l'anno. Risparmia {amount} all'anno.",
  'upsell.banner.annualNowText':
    "Con il piano annuale, tutti i {minutes} minuti sono disponibili subito e restano disponibili tutto l'anno. Risparmia {amount} all'anno.",
  'upsell.banner.annualShortText':
    "Tutti i {minutes} minuti subito, disponibili tutto l'anno. Risparmia {amount} all'anno.",
  'upsell.banner.businessGivesMonth':
    'Business ti offre {minutes} minuti al mese, oltre al Dizionario e a più lingue contemporaneamente.',
  'upsell.banner.businessGivesYear':
    "Business ti offre {minutes} minuti per l'anno, oltre al Dizionario e a più lingue contemporaneamente.",
  'upsell.banner.businessText': 'Ottieni {minutes} minuti al mese e il Dizionario per termini coerenti.',
  'upsell.banner.businessTitle': 'Traduci in più lingue contemporaneamente con Business.',
  'upsell.banner.creatorProGivesMonth':
    'Creator Pro ti offre {minutes} minuti al mese, oltre a download con Lip-sync e sottotitoli.',
  'upsell.banner.creatorProGivesYear':
    "Creator Pro ti offre {minutes} minuti per l'anno, oltre a download con Lip-sync e sottotitoli.",
  'upsell.banner.creatorProText': 'Ottieni {minutes} minuti al mese, sottotitoli sul video ed esportazione SRT.',
  'upsell.banner.creatorProTitle': 'Scarica video con Lip-sync con Creator Pro.',
  'upsell.banner.dismiss': 'Ignora',
  'upsell.banner.fullYearTitle': "Ottieni subito i minuti di tutto l'anno.",
  'upsell.banner.usedHalfMonth': 'Hai usato metà dei tuoi minuti di questo mese.',
  'upsell.banner.usedHalfYear': 'Hai usato metà dei tuoi minuti annuali.',
  'upsell.counter.left': '{minutes} min rimanenti',
  'upsell.counter.used': '{percent}% usato · {minutes} min rimanenti',
  'upsell.download.annualTitle': "Ottieni subito i minuti di tutto l'anno",
  'upsell.download.businessTitle': 'Traduci in più lingue contemporaneamente',
  'upsell.download.creatorProTitle': 'Porta questo video oltre con Creator Pro',
  'upsell.download.dictionary': 'Mantieni una terminologia coerente in tutti i progetti con il Dizionario',
  'upsell.download.done': 'Il tuo video è stato scaricato',
  'upsell.download.doneAudio': 'Il tuo audio è stato scaricato',
  'upsell.download.doneSubtitles': 'I tuoi sottotitoli sono stati scaricati',
  'upsell.download.lipSync': 'Scaricalo con il Lip-sync per più locutori',
  'upsell.download.multilanguage': 'Traduzione in più lingue con un clic',
  'upsell.download.subtitles': 'Aggiungi sottotitoli o esporta file SRT',
  'upsell.feature.dictionary': 'Termini coerenti con il Dizionario',
  'upsell.feature.lipSync': 'Lip-sync per più locutori incluso',
  'upsell.feature.minutesInsteadMonth': '{minutes} minuti al mese invece di {from}',
  'upsell.feature.minutesInsteadYear': "{minutes} minuti all'anno invece di {from}",
  'upsell.feature.minutesPerMonth': '{minutes} minuti al mese',
  'upsell.feature.minutesPerMonthShort': '{minutes} minuti/mese',
  'upsell.feature.minutesPerYear': "{minutes} minuti per l'anno",
  'upsell.feature.minutesStay': "I minuti restano disponibili tutto l'anno",
  'upsell.feature.multilanguage': 'Traduci in più lingue contemporaneamente',
  'upsell.feature.poolDayOne': 'Tutti i {minutes} minuti disponibili dal primo giorno',
  'upsell.feature.poolUpfront': 'Tutti i {minutes} minuti disponibili subito',
  'upsell.feature.save': 'Risparmia {amount}',
  'upsell.feature.saveYear': "Risparmia {amount} all'anno",
  'upsell.feature.subtitles': 'Aggiungi sottotitoli ed esporta file SRT',
  'upsell.hero.annualPlan': '{plan} annuale',
  'upsell.hero.current': 'Attuale · {plan} · {minutes} min',
  'upsell.hero.fullYear': "Tutto l'anno · disponibili ora",
  'upsell.hero.lipSync': 'Lip-sync',
  'upsell.hero.minutes': '{minutes} min',
  'upsell.hero.multiplier': '{multiplier}× minuti',
  'upsell.hero.savePerYear': 'Risparmia {amount}/anno',
  'upsell.price.perMonth': '{price}/mese',
  'upsell.price.perYear': '{price}/anno',
  'upsell.usage.annualTitle': "Conserva i tuoi minuti per tutto l'anno",
  'upsell.usage.tierMonthTitle': 'Ottieni {minutes} minuti al mese con {plan}',
  'upsell.usage.tierMultiplierTitle': 'Ottieni {multiplier}× minuti con {plan}',
  'upsell.usage.tierYearTitle': "Ottieni {minutes} minuti all'anno con {plan}",
  'upsell.usage.usedMonth': 'Hai usato {used} minuti su {total} questo mese',
  'upsell.usage.usedYear': "Hai usato {used} minuti su {total} quest'anno",
  'upsell.welcome.dictionary': 'Dizionario per termini coerenti',
  'upsell.welcome.includes': 'Il tuo piano include',
  'upsell.welcome.languages': 'Oltre 135 lingue, con la modifica di ogni battuta',
  'upsell.welcome.lipSyncDownloads': 'Download dei video con Lip-sync',
  'upsell.welcome.lipSyncSubtitles': 'Download con Lip-sync e sottotitoli',
  'upsell.welcome.minutesMonth': '{minutes} minuti al mese per doppiaggio e traduzione',
  'upsell.welcome.minutesYear': "{minutes} minuti per l'anno, disponibili subito",
  'upsell.welcome.multilanguage': 'Traduzione in più lingue con un clic',
  'upsell.welcome.needMore': 'Ti serve di più?',
  'upsell.welcome.offerMonth': '{plan} ti offre {minutes} minuti al mese, e in più:',
  'upsell.welcome.offerYear': "{plan} annuale ti offre {minutes} minuti per l'anno, e in più:",
  'upsell.welcome.srtVoices': 'Esportazione SRT e fino a 3 voci salvate',
  'upsell.welcome.subtitlesSrt': 'Sottotitoli sul video, esportazione e importazione SRT',
  'upsell.welcome.title': 'Benvenuto in {plan}',
  'upsell.welcome.voiceCloning': 'Clonazione vocale che mantiene la voce di ogni locutore',
} satisfies UpsellTranslation;

const ru = {
  'upsell.action.maybeLater': 'Возможно, позже',
  'upsell.action.orSwitchToAnnual': 'Или перейдите на годовой тариф — минуты останутся с вами весь год',
  'upsell.action.orUpgradeTo': 'Или перейдите на {plan}',
  'upsell.action.startTranslating': 'Начать перевод',
  'upsell.action.switchToAnnual': 'Перейти на годовой · {price}',
  'upsell.action.upgradeTo': 'Перейти на {plan} · {price}',
  'upsell.banner.annualDayOneText':
    'На годовом тарифе все {minutes} мин доступны с первого дня и весь год. Экономия {amount} в год.',
  'upsell.banner.annualNowText':
    'На годовом тарифе все {minutes} мин доступны сразу и весь год. Экономия {amount} в год.',
  'upsell.banner.annualShortText': 'Все {minutes} мин сразу и на весь год. Экономия {amount} в год.',
  'upsell.banner.businessGivesMonth':
    'Business даёт {minutes} мин в месяц, а также словарь и перевод сразу на несколько языков.',
  'upsell.banner.businessGivesYear':
    'Business даёт {minutes} мин на весь год, а также словарь и перевод сразу на несколько языков.',
  'upsell.banner.businessText': '{minutes} мин в месяц и словарь для единообразной терминологии.',
  'upsell.banner.businessTitle': 'Переводите сразу на несколько языков с тарифом Business.',
  'upsell.banner.creatorProGivesMonth':
    'Creator Pro даёт {minutes} мин в месяц, а также возможность скачивать видео с липсинком и добавлять субтитры.',
  'upsell.banner.creatorProGivesYear':
    'Creator Pro даёт {minutes} мин на весь год, а также возможность скачивать видео с липсинком и добавлять субтитры.',
  'upsell.banner.creatorProText': '{minutes} мин в месяц, субтитры на видео и экспорт SRT.',
  'upsell.banner.creatorProTitle': 'Скачивайте видео с липсинком на тарифе Creator Pro.',
  'upsell.banner.dismiss': 'Скрыть',
  'upsell.banner.fullYearTitle': 'Получите минуты на весь год сразу.',
  'upsell.banner.usedHalfMonth': 'Вы использовали половину минут этого месяца.',
  'upsell.banner.usedHalfYear': 'Вы использовали половину годовых минут.',
  'upsell.counter.left': 'осталось {minutes} мин',
  'upsell.counter.used': 'Использовано {percent}% · осталось {minutes} мин',
  'upsell.download.annualTitle': 'Получите минуты на весь год сразу',
  'upsell.download.businessTitle': 'Переводите сразу на несколько языков',
  'upsell.download.creatorProTitle': 'Больше возможностей для этого видео с Creator Pro',
  'upsell.download.dictionary': 'Единая терминология во всех проектах благодаря словарю',
  'upsell.download.done': 'Видео скачано',
  'upsell.download.doneAudio': 'Аудио скачано',
  'upsell.download.doneSubtitles': 'Субтитры скачаны',
  'upsell.download.lipSync': 'Скачайте его с липсинком для нескольких спикеров',
  'upsell.download.multilanguage': 'Пакетный перевод на несколько языков в один клик',
  'upsell.download.subtitles': 'Добавьте субтитры или экспортируйте файлы SRT',
  'upsell.feature.dictionary': 'Единые термины благодаря словарю',
  'upsell.feature.lipSync': 'Липсинк для нескольких спикеров включён',
  'upsell.feature.minutesInsteadMonth': '{minutes} мин в месяц вместо {from}',
  'upsell.feature.minutesInsteadYear': '{minutes} мин в год вместо {from}',
  'upsell.feature.minutesPerMonth': '{minutes} мин в месяц',
  'upsell.feature.minutesPerMonthShort': '{minutes} мин/мес.',
  'upsell.feature.minutesPerYear': '{minutes} мин на год',
  'upsell.feature.minutesStay': 'Минуты доступны весь год',
  'upsell.feature.multilanguage': 'Перевод сразу на несколько языков',
  'upsell.feature.poolDayOne': 'Все {minutes} мин доступны с первого дня',
  'upsell.feature.poolUpfront': 'Все {minutes} мин доступны сразу',
  'upsell.feature.save': 'Экономия {amount}',
  'upsell.feature.saveYear': 'Экономия {amount} в год',
  'upsell.feature.subtitles': 'Субтитры и экспорт файлов SRT',
  'upsell.hero.annualPlan': '{plan} на год',
  'upsell.hero.current': 'Сейчас · {plan} · {minutes} мин',
  'upsell.hero.fullYear': 'На весь год · доступны сразу',
  'upsell.hero.lipSync': 'Липсинк',
  'upsell.hero.minutes': '{minutes} мин',
  'upsell.hero.multiplier': '{multiplier}× минут',
  'upsell.hero.savePerYear': 'Экономия {amount}/год',
  'upsell.price.perMonth': '{price}/мес.',
  'upsell.price.perYear': '{price}/год',
  'upsell.usage.annualTitle': 'Сохраните минуты на весь год',
  'upsell.usage.tierMonthTitle': '{minutes} мин в месяц на {plan}',
  'upsell.usage.tierMultiplierTitle': 'В {multiplier} раза больше минут на {plan}',
  'upsell.usage.tierYearTitle': '{minutes} мин в год на {plan}',
  'upsell.usage.usedMonth': 'Вы использовали {used} из {total} мин в этом месяце',
  'upsell.usage.usedYear': 'Вы использовали {used} из {total} мин в этом году',
  'upsell.welcome.dictionary': 'Словарь для единых терминов',
  'upsell.welcome.includes': 'В ваш тариф входит',
  'upsell.welcome.languages': 'Более 135 языков с редактированием каждой реплики',
  'upsell.welcome.lipSyncDownloads': 'Скачивание видео с липсинком',
  'upsell.welcome.lipSyncSubtitles': 'Скачивание видео с липсинком и субтитрами',
  'upsell.welcome.minutesMonth': '{minutes} мин в месяц на дубляж и перевод',
  'upsell.welcome.minutesYear': '{minutes} мин на год, доступны сразу',
  'upsell.welcome.multilanguage': 'Перевод на несколько языков в один клик',
  'upsell.welcome.needMore': 'Нужно больше?',
  'upsell.welcome.offerMonth': '{plan} даёт {minutes} мин в месяц, а также:',
  'upsell.welcome.offerYear': '{plan} на год даёт {minutes} мин на весь год, а также:',
  'upsell.welcome.srtVoices': 'Экспорт SRT и до 3 сохранённых голосов',
  'upsell.welcome.subtitlesSrt': 'Субтитры на видео, экспорт и импорт SRT',
  'upsell.welcome.title': 'Добро пожаловать в {plan}',
  'upsell.welcome.voiceCloning': 'Клонирование голоса с сохранением тембра спикера',
} satisfies UpsellTranslation;

export const UPSELL_TRANSLATIONS = defineDomainTranslations({ en, es, fr, it, pt, ru });
